export const getBlockedRepresentatives = (usersData: any[]) => {
  if (!Array.isArray(usersData)) return [];
  return usersData.filter(
    (user: any) =>
      user.isRegisterBlocked &&
      user.permission &&
      user.permission.name === 'REPRESENTANTE LEGAL MUNICIPAL',
  );
};
